import moduleCommon from "@/store/common/moduleCommon.js";
import Api from "@/helpers/api.js";
import {Validator} from "vee-validate";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import PopupMap from "@/components/optimization/visit-point/PopupMap.vue";
import {MapFeatures} from "@/plugins/mapFeatures";
import ManageErrorMessages from "@/models/ManageErrorMessages";
import phonesSuccess from "@/assets/images/markers/phones_success.png";
import {en, es} from "vuejs-datepicker/src/locale";
import Datepicker from "vuejs-datepicker";
import DateUtils from "@/helpers/DateUtils.js";
import Utils from "@/helpers/Utils";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleMap from "@/store/map/moduleMap.js";
import moment from "moment";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export const resourceEditMixin = {
	name: "ResourceUpdate",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		Datepicker,
		PopupMap,
		VuePerfectScrollbar,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			titlePromptErrorVisitPoint: "",
			activeTab: 0,
			popupMapMounted: false,
			dataCity: null,
			selectedCountry: null,
			selectedDepartment: null,
			departments: [],
			countries: [],
			cities: [],
			showButtonAddCoordinates: true,
			dataGeo: {},
			showPromptField: false,
			showPromptDemand: false,
			showPromptBreak: false,
			showPromptSkill: false,
			propertiesList: [],
			propertiesListDemand: [],
			propertiesListSkill: [],
			propertiesListBreak: [],
			listErrorFilter: [],
			arrayErrors: [],
			isUpdate: false,
			isUpdateDemand: false,
			isUpdateBreak: false,
			isUpdateSkill: false,
			indexUpdate: null,
			indexUpdateDemand: null,
			indexUpdateBreak: null,
			indexUpdateSkill: null,
			showGeoAgaing: false,
			isDisabled: true,
			activeAlert: true,
			isClusteredRoute: true,
			activePromptErrorVisitPoint: false,
			marker: null,
			validFormTimeWindowComputed: true,
			isTimeWindow: false,
			manageErrorMessages: new ManageErrorMessages({that: this}),
			resourceEdit: {...this.data},
			geoAlert: false,
			geoAlertAddress: false,
			activeAlertError: false,
			isDisabledIdentification: true,
			langHe: es,
			langEn: en,
			isSoftTimeWindow: false,
			isAlertTimeWindow: false,
			closeInfo: true,
			propertiesListTerritory: [],
			showPromptTerritory: false,
			isUpdateTerritory: false,
			indexUpdateTerritory: null,
			resource: {
				identification: "",
				original_identification: "",
				hours: 0,
				minutes: 0,
				seconds: 0,
				max_travel_duration: "",
				max_travel_distance: "",
				init_depot: "",
				end_depot: "",
				profile: "",
				skill: "",
				additional_info: {},
				strict_territories: false,
				territories: {
					id: "",
					priority: 0,
				},
				clustering: {
					max_distance_to_neighbor: 25,
					max_diameter: 100,
				},
				capacity: {
					name: "",
					amount: "",
				},
				time_window: {
					init_date_window: "",
					end_date_window: "",
					init_hour_window: "",
					end_hour_window: "",
				},
				breaks: {
					init_date_window: "",
					end_date_window: "",
					init_hour_window: "",
					end_hour_window: "",
				},
				min_break_hours: 0,
				min_break_minutes: 0,
				min_break_seconds: 0,
				costs: {
					distance: 0,
					fixed: 0,
					time: 0,
					traveled_hour: 0,
				},
			},
			profileOptions: [
				{
					label: this.$t("Routing.Car"),
					value: "car",
				},
				{
					label: this.$t("Routing.Walking"),
					value: "walk",
				},
				{
					label: this.$t("Routing.Bicycle"),
					value: "bicycle",
				},
				{
					label: this.$t("Routing.Motorcycle"),
					value: "motorcycle",
				},
				{
					label: this.$t("Routing.Truck"),
					value: "truck",
				},
				{
					label: this.$t("Routing.Scooter"),
					value: "scooter",
				},
				{
					label: this.$t("Routing.Bus"),
					value: "bus",
				},
			],
			mapConfig: {
				name: "optimization-map",
				latitude: 4.686699,
				longitude: -74.0837187,
				zoom: "13",
				theme: "uber",
				calledFrom: "DinamicFields",
			},
			formatData: {
				country: "",
				department: "",
				city: "",
				address: "",
				addressOld: "",
				cx: 0,
				cy: 0,
				typeDeposit: "InitDeposit",
			},
			settingsForm: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			configTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
				time_24hr: true,
			},
			property: {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			},
			type: [
				{
					label: "Text",
					value: "text",
				},
				{
					label: "Date",
					value: "date",
				},
				{
					label: "Time",
					value: "time",
				},
				{
					label: "Number",
					value: "number",
				},
			],
		};
	},
	computed: {
		countriesOptions() {
			return this.generateOptionSelect(this.$store.state.moduleCommon.countries, "country_name", "country_name");
		},
		validateForm() {
			return !this.errors.any();
		},
		vsPopupTitle() {
			return `${this.$t("Select")} ${this.$t("Routing.Point")}`;
		},
		disabledDatesTo() {
			return {to: new Date(this.resource.time_window.init_date_window)};
		},
		getDateWithoutTime() {
			return (date) => {
				return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
			};
		},
		showErrorSoftWindow() {
			return (generalWindow, fieldTimeWindow, fieldSoftWindow) => {
				const softTimeDate = new Date(generalWindow.soft_time_window[fieldSoftWindow]);
				const generalDate = new Date(generalWindow[fieldTimeWindow]);
				return softTimeDate != "" && fieldTimeWindow === "init_date_window"
					? this.getDateWithoutTime(softTimeDate) < this.getDateWithoutTime(generalDate)
					: this.getDateWithoutTime(softTimeDate) > this.getDateWithoutTime(generalDate);
			};
		},
		showErrorSoftWindowHour() {
			return (generalWindow, fieldGeneralWindow, fieldSoftWindow) => {
				const softTimeDate = generalWindow.soft_time_window[fieldSoftWindow];
				const generalDate = generalWindow[fieldGeneralWindow];
				return (
					softTimeDate !== "" &&
					(fieldGeneralWindow === "init_hour_window"
						? this.stringTimeToDate(softTimeDate) < this.stringTimeToDate(generalDate)
						: this.stringTimeToDate(softTimeDate) > this.stringTimeToDate(generalDate))
				);
			};
		},
		isStartBeforeEnd() {
			return (generalWindow, fieldInit, fieldEnd) => {
				const softTimeDateInit =
					fieldInit === "init_hour"
						? generalWindow.soft_time_window[fieldInit]
						: this.getDateWithoutTime(new Date(generalWindow.soft_time_window[fieldInit]));
				const softTimeDateEnd =
					fieldInit === "init_hour"
						? generalWindow.soft_time_window[fieldEnd]
						: this.getDateWithoutTime(new Date(generalWindow.soft_time_window[fieldEnd]));
				return fieldInit === "init_hour"
					? this.stringTimeToDate(softTimeDateInit) > this.stringTimeToDate(softTimeDateEnd)
					: softTimeDateInit > softTimeDateEnd;
			};
		},
		validFormAdditionalFields() {
			return this.property.label.length > 0 && this.property.value.length > 0;
		},
		validFormDemand() {
			return this.resource.capacity.name.length > 0 && this.resource.capacity.amount.length > 0;
		},
		validFormTerritory() {
			return this.resource.territories.id.length > 0 && this.resource.territories.priority.length > 0;
		},
		validFormSkill() {
			return this.resource.skill.length > 0;
		},
		validFormBreak() {
			return (
				this.resource.breaks.init_date_window !== "" &&
				this.resource.breaks.end_date_window !== "" &&
				this.resource.breaks.init_hour_window !== "" &&
				this.resource.breaks.end_hour_window !== "" &&
				Date.parse(this.resource.breaks.end_date_window) - Date.parse(this.resource.breaks.init_date_window) >=
					0 &&
				!this.errors.has("dataHourInit") &&
				!this.errors.has("dataHourEnd") &&
				!this.errors.has("minBreakDuration")
			);
		},
		validFormTimeWindow: {
			get() {
				this.validFormTimeWindowComputed =
					this.resource.time_window.init_date_window !== "" &&
					this.resource.time_window.end_date_window !== "" &&
					this.resource.time_window.init_hour_window !== "" &&
					this.resource.time_window.end_hour_window !== "" &&
					Date.parse(this.resource.time_window.end_date_window) -
						Date.parse(this.resource.time_window.init_date_window) >=
						0 &&
					!this.errors.has("dataHourInit") &&
					!this.errors.has("dataHourEnd");
				return this.resource.time_window.hasOwnProperty("soft_time_window")
					? this.validFormTimeWindowComputed && this.validFormSoftTimeWindow
					: this.validFormTimeWindowComputed;
			},
			set(val) {
				this.validFormTimeWindowComputed = val;
				return this.validFormTimeWindowComputed;
			},
		},
		validFormSoftTimeWindow() {
			return (
				this.resource.time_window.soft_time_window.init_date !== "" &&
				this.resource.time_window.soft_time_window.end_date !== "" &&
				this.resource.time_window.soft_time_window.init_hour !== "" &&
				this.resource.time_window.soft_time_window.end_hour !== "" &&
				!this.isStartBeforeEnd(this.resource.time_window, "init_date", "end_date") &&
				!this.showErrorSoftWindow(this.resource.time_window, "init_date_window", "init_date") &&
				!this.showErrorSoftWindow(this.resource.time_window, "end_date_window", "end_date") &&
				!this.isStartBeforeEnd(this.resource.time_window, "init_hour", "end_hour") &&
				!this.showErrorSoftWindowHour(this.resource.time_window, "init_hour_window", "init_hour") &&
				!this.showErrorSoftWindowHour(this.resource.time_window, "end_hour_window", "end_hour")
			);
		},
		validateErrorProperty() {
			return function (propertyNameFirst) {
				return this.$store.state.moduleOptimization.errorList.filter(
					(element) =>
						element.absolute_path[0] === "vehicles" &&
						element.absolute_path[1] === this.resourceEdit.indexResource &&
						element.absolute_path.includes(propertyNameFirst)
				);
			};
		},
		validateErrorPropertyArray() {
			return function (propertyName, index) {
				return this.$store.state.moduleOptimization.errorList.filter(
					(element) =>
						element.absolute_path[0] === "vehicles" &&
						element.absolute_path[1] === this.resourceEdit.indexResource &&
						element.absolute_path.includes(propertyName) &&
						element.absolute_path[3] === index
				);
			};
		},
		optimizersList() {
			return this.$store.state.moduleOptimization.listCompanyOptimizers;
		},
	},
	mounted() {
		this.showPromptErrorService();
		this.checkIdentification();
		this.setAdditionalInfo();
		this.setIdentificationAndDistance();
		this.setInitDepot();
		this.setProperties();
		this.setProfile();
		this.setTravelDuration();
		this.setCosts();
		this.setClustering();
		this.setTimeWindow();
		this.setEndDepot();
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		geoCoder() {
			const {country, city, address, department} = this.formatData;
			if (address === null || address === undefined || address === "") {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPoints.MissingAddress.Title"),
					text: this.$t("VisitPoints.MissingAddress.Text"),
				});
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address, department})
				.then((res) => {
					this.closeLoading();
					if (res.status !== 200) {
						throw new Error("Not georreferencer address");
					}
					if (res.status === 200 && res.message === "Procesado y no ubicado.") {
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPoints.Georeferencer"),
							text: this.$t("VisitPoints.AddressCouldBeNotGeoreferenced"),
						});
						return;
					}

					if (res.status === 200) {
						this.dataGeo = {...res.data};
						this.formatData.cy = parseFloat(this.dataGeo.latitude);
						this.formatData.cx = parseFloat(this.dataGeo.longitude);
						this.formatData.cy.toFixed(8);
						this.formatData.cx.toFixed(8);
						this.geoAlertAddress = false;
						this.showButtonAddCoordinates = true;
						if (this.dataGeo.latitude !== "0" || this.dataGeo.longitude !== "0") {
							this.$vs.notify({
								color: "success",
								title: this.$t("VisitPoints.FindAddress.Title"),
								text: this.$t("VisitPoints.FindAddress.Text"),
							});
							this.showGeoAgaing = true;
							this.map.removeMarker(this.marker);
							this.marker = this.map.addMarkerToMap(this.formatData, {
								icon: phonesSuccess,
								draggable: true,
								infoWindow: {
									content: `
										<div class='flex items-center mt-2'>
											<span class='text-ms'>${formatData.cy}, ${formatData.cx}</span>
										</div>
									`,
								},
								onDragend: (coords) => {
									this.geoReverse({
										cy: coords.lat,
										cx: coords.lng,
									});
								},
							});
							this.isDisabled = true;
						} else {
							this.$vs.notify({
								color: "warning",
								title: this.$t("VisitPoints.ErrorFindAddress.Title"),
								text: this.$t("VisitPoints.ErrorFindAddress.Text"),
							});
						}
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		geoReverse({cy, cx}) {
			this.openLoading();
			this.isDisabled = true;
			this.$store
				.dispatch("moduleMap/geoinverso", {cy, cx})
				.then((res) => {
					this.closeLoading();
					if (res.data.address1 !== this.formatData.address) {
						this.formatData.cy = cy.toFixed(8);
						this.formatData.cx = cx.toFixed(8);
						this.formatData.address = res.data.address1;
						this.formatData.addressOld = res.data.address1;
						this.selectedCountry = res.data.country_long_name;
						this.selectedDepartment = res.data.department1;
						this.dataCity = res.data.city1;
						this.showButtonAddCoordinates = true;
						this.geoAlertAddress = false;
					}
					if (res.status === 200 && (res.data.status === "C" || res.data.status === "")) {
						this.formatData.cy = 0;
						this.formatData.cx = 0;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPoints.ErrorFindAddress.Title"),
							text:
								this.$t("VisitPoints.ErrorFindAddress.Text") +
								", " +
								this.$t("VisitPoints.ErrorFindCountry.Text"),
							time: 7000,
						});
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		getInstanceMap(data) {
			const map = data.map;
			this.marker = data.marker;
			this.map = new MapFeatures(map);
		},
		cancelAction() {
			this.formatData.address = this.formatData.addressOld;
			this.showButtonAddCoordinates = true;
			this.isDisabled = true;
			this.geoAlertAddress = false;
		},
		generateOptionSelect(data, propLabel, propValue) {
			if (!Array.isArray(data)) {
				return [];
			}
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		addResource() {
			if (!this.validFormTimeWindow && this.isTimeWindow) {
				this.notifyWarning(
					this.$t("MissingFieldTitle"),
					`${this.$t("ResourceModule.BasicInfoForm.Messages.AllFieldsRequired")} ${this.$t(
						"TimeWindow.TimeWindow"
					)}`
				);
				this.isAlertTimeWindow = true;
				return;
			}
			this.$vs.loading();
			this.isAlertTimeWindow = false;
			this.$validator.validateAll("update-resource").then(async (result) => {
				if (result) {
					const payloadStandardInput = this.buildPayload();
					this.cleanPayload(payloadStandardInput);
					this.$store.commit("moduleOptimization/UPDATE_VEHICLE_STANDARD_INPUT", payloadStandardInput);
					this.$vs.loading.close();
					this.$emit("vehicleList", payloadStandardInput);
					this.closeSidebarAddResource();
				} else {
					this.notifyWarning(this.$t("MissingFieldTitle"), this.$t("ErrorFields.Text"));
					this.$vs.loading.close();
				}
			});
		},
		notifyWarning(title, text) {
			this.$vs.notify({
				color: "warning",
				title: title,
				text: text,
			});
		},
		buildPayload() {
			const coordinatesInitDepot = this.getCoordinates(this.resource.init_depot);
			const endDepot = this.getEndDepotCoordinates();
			return {
				identification: this.resource.identification,
				original_identification: this.resource.original_identification,
				profile: this.resource.profile.value,
				max_travel_distance: this.resource.max_travel_distance,
				max_travel_duration: this.formatTravelDuration(),
				init_depot: coordinatesInitDepot,
				end_depot: endDepot,
				costs: Utils.convertItemObjectToNumbers(this.resource.costs),
				skills: this.propertiesListSkill || [],
				capacity: this.propertiesListDemand || [],
				time_window: this.processTimeWindow(),
				breaks: this.processBreaks(),
				additional_info: this.resource.additional_info,
				clustering: this.isClusteredRoute ? Utils.convertItemObjectToNumbers(this.resource.clustering) : null,
				territories: {
					strict: this.resource.strict_territories || false,
					items: this.propertiesListTerritory || [],
				},
			};
		},
		getCoordinates(depot) {
			const [lat, lng] = depot.split(",");
			return {latitude: parseFloat(lat), longitude: parseFloat(lng)};
		},
		getEndDepotCoordinates() {
			if (!this.resource.end_depot) return {};
			return this.getCoordinates(this.resource.end_depot);
		},
		formatTravelDuration() {
			const {hours, minutes, seconds} = this.resource;
			return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}:${
				seconds < 10 ? "0" + seconds : seconds
			}`;
		},
		processTimeWindow() {
			const timeWindow = {...this.resource.time_window};
			if (!timeWindow.init_date_window && !timeWindow.end_date_window) {
				timeWindow.init_date_window = "";
				timeWindow.end_date_window = "";
			} else {
				timeWindow.init_date_window = DateUtils.toDefaultDateTime(timeWindow.init_date_window, "YYYY-MM-DD");
				timeWindow.end_date_window = DateUtils.toDefaultDateTime(timeWindow.end_date_window, "YYYY-MM-DD");
				if (timeWindow.soft_time_window && this.isSoftTimeWindow) {
					this.processSoftTimeWindow(timeWindow.soft_time_window);
				}
			}
			return timeWindow;
		},
		processBreaks() {
			return this.propertiesListBreak.map((breakItem) => {
				const processedBreak = {
					init_date_window: DateUtils.toDefaultDateTime(breakItem.init_date_window, "YYYY-MM-DD"),
					end_date_window: DateUtils.toDefaultDateTime(breakItem.end_date_window, "YYYY-MM-DD"),
					init_hour_window: breakItem.init_hour_window,
					end_hour_window: breakItem.end_hour_window,
				};

				// Agregar min_break_duration solo si hay valores
				if (
					breakItem.min_break_hours > 0 ||
					breakItem.min_break_minutes > 0 ||
					breakItem.min_break_seconds > 0
				) {
					processedBreak.min_break_duration = this.formatMinBreakDuration(breakItem);
				}

				return processedBreak;
			});
		},
		processSoftTimeWindow(softTimeWindow) {
			softTimeWindow.cost_per_hour_before = parseInt(softTimeWindow.cost_per_hour_before);
			softTimeWindow.cost_per_hour_after = parseInt(softTimeWindow.cost_per_hour_after);
			softTimeWindow.init_date = DateUtils.toDefaultDateTime(softTimeWindow.init_date, "YYYY-MM-DD");
			softTimeWindow.end_date = DateUtils.toDefaultDateTime(softTimeWindow.end_date, "YYYY-MM-DD");
		},
		cleanPayload(payload) {
			const fieldsToCheck = [
				"skills",
				"capacity",
				"breaks",
				"additional_info",
				"costs",
				"end_depot",
				"time_window",
				"profile",
				"max_travel_distance",
				"max_travel_duration",
				"original_identification",
			];

			fieldsToCheck.forEach((field) => {
				if (this.isEmptyField(payload[field])) delete payload[field];
			});

			if (payload.territories && (!payload.territories.items || payload.territories.items.length === 0)) {
				delete payload.territories;
			}

			if (payload.clustering === null || payload.clustering === undefined) {
				delete payload.clustering;
			}

			if (
				payload.time_window &&
				payload.time_window.init_date_window === "" &&
				payload.time_window.end_date_window === "" &&
				payload.time_window.init_hour_window === "" &&
				payload.time_window.end_hour_window === ""
			) {
				delete payload["time_window"];
			}
		},
		isEmptyField(field) {
			if (Array.isArray(field)) return field.length === 0;
			if (typeof field === "object") return Object.keys(field).length === 0;
			return !field;
		},
		validateErrorRegister(error) {
			if (error.data === null || error.data === undefined) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: this.$t("VisitPoints.ErrorRegisterValidate.Text"),
				});
				return;
			}
			if (error.data.reason.length > 0) {
				let reason = Array.from(new Set(error.data.reason.flatMap(({absolute_path}) => absolute_path)));
				let reasonFiltered = reason
					.filter((m) => m !== "additional_info")
					.map((m) => `${m.toUpperCase()}: ${this.$t("Routing.Messages.ValidatorRequiredProperty")} `)
					.join("; ");
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: reasonFiltered,
					time: 6000,
				});
			}
		},
		getCities(departmentName) {
			Api.post("/divipola", {
				country: typeof this.selectedCountry === "object" ? this.selectedCountry.value : this.selectedCountry,
				department: departmentName ? departmentName.replaceAll(",", "") : "",
				city: "",
				world_code: "",
				only: "city_name",
				fields: ["city_name"],
			})
				.then((res) => {
					this.cities = this.generateOptionSelect(res.data, "city_name", "city_name");
				})
				.catch((e) => {
					console.error("❌ Error Getting Cities", e);
				});
		},
		getDepartments(countryName) {
			Api.post("/divipola", {
				country: countryName,
				department: "",
				city: "",
				world_code: "",
				only: "department_name",
				fields: ["department_name"],
			})
				.then((res) => {
					this.departments = this.generateOptionSelect(res.data, "department_name", "department_name");
				})
				.catch((e) => {
					console.error("❌ Error Getting Department name", e);
				});
		},
		addProperty(property) {
			let findOther = this.propertiesList.findIndex((elem) => elem.label === property.label);
			if (findOther == -1) {
				this.propertiesList.push(property);
				this.resource.additional_info[property.label] = property.value;
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdate) {
				this.updateProperty(property);
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		addPropertyDemand(propertyDemand) {
			propertyDemand = {
				name: propertyDemand.name,
				amount: parseInt(propertyDemand.amount),
			};
			let findOther = this.propertiesListDemand.findIndex((elem) => elem.name === propertyDemand.name);
			if (findOther == -1) {
				this.propertiesListDemand.push(propertyDemand);
				this.resource.capacity = {
					name: "",
					amount: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdateDemand) {
				this.updatePropertyDemand(propertyDemand);
				this.resource.capacity = {
					name: "",
					amount: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		deleteItem(data, indexItem) {
			this.propertiesList.splice(indexItem, 1);
			delete this.resource.additional_info[data.label];
		},
		editSelect(val, index) {
			this.isUpdate = true;
			this.showPromptField = true;
			this.property.label = val.label;
			this.property.value = val.value;
			this.property.type = val.type;
			this.indexUpdate = index;
		},
		updateProperty(property) {
			this.propertiesList[this.indexUpdate].label = property.label;
			this.propertiesList[this.indexUpdate].value = property.value;
			this.propertiesList[this.indexUpdate].type = property.type;
			this.resource.additional_info[property.label] = property.value;
		},
		deleteItemDemand(data, indexItem) {
			this.propertiesListDemand.splice(indexItem, 1);
		},
		editSelectDemand(val, index) {
			this.isUpdateDemand = true;
			this.showPromptDemand = true;
			this.resource.capacity.name = val.name;
			this.resource.capacity.amount = val.amount;
			this.indexUpdateDemand = index;
		},
		updatePropertyDemand(propertyDemand) {
			this.propertiesListDemand[this.indexUpdateDemand].name = propertyDemand.name;
			this.propertiesListDemand[this.indexUpdateDemand].amount = propertyDemand.amount;
		},
		showPrompt() {
			this.showPromptField = true;
			this.isUpdate = false;
			this.property = {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			};
		},
		showPromptDemands() {
			this.showPromptDemand = true;
			this.isUpdateDemand = false;
			this.resource.capacity = {
				name: "",
				amount: "",
			};
		},
		showPromptSkills() {
			this.showPromptSkill = true;
			this.isUpdateSkill = false;
			this.resource.skill = "";
		},
		updatePropertySkill(propertySkill) {
			this.propertiesListSkill[this.indexUpdateSkill] = propertySkill;
		},
		deleteItemSkill(indexItem) {
			this.propertiesListSkill.splice(indexItem, 1);
		},
		addPropertySkill(propertySkill) {
			let findOther = this.propertiesListSkill.findIndex((elem) => elem === propertySkill);
			if (this.isUpdateSkill) {
				this.updatePropertySkill(propertySkill);
				this.resource.skill = "";
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (findOther == -1) {
				this.propertiesListSkill.push(propertySkill);
				this.resource.skill = "";
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		validateKeyAdditionalInfo(event) {
			let regex = /^[a-zA-Z_]\w*$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateAmountNumber(event) {
			let regex = /^\d+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumber(event) {
			if (this.resource.hours.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberMinutes(event) {
			if (this.resource.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(event) {
			if (this.resource.seconds.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberPriority(event) {
			if (this.hours.length === 3) {
				event.preventDefault();
				return false;
			}
		},
		openMapInitDeposit() {
			if (
				this.resource.init_depot !== undefined &&
				this.resource.init_depot !== null &&
				this.resource.init_depot !== ""
			) {
				const divideCoordinates = this.resource.init_depot.split(",");
				const coordinates = {
					lat: divideCoordinates[0],
					lng: divideCoordinates[1],
				};
				this.mapConfig.latitude = parseFloat(coordinates.lat);
				this.mapConfig.longitude = parseFloat(coordinates.lng);
				this.showGeoAgain = false;
			} else {
				this.formatData = {
					country: "",
					department: "",
					city: "",
					address: "",
					addressOld: "",
					cx: 0,
					cy: 0,
					typeDeposit: "InitDeposit",
				};
			}
			this.formatData.typeDeposit = "InitDeposit";
			this.isDisabled = true;
			this.popupMapMounted = true;
			this.geoAlert = true;
		},
		openMapEndDeposit() {
			if (
				this.resource.end_depot !== undefined &&
				this.resource.end_depot !== null &&
				this.resource.end_depot !== ""
			) {
				const divideCoordinates = this.resource.end_depot.split(",");
				const coordinates = {
					lat: divideCoordinates[0],
					lng: divideCoordinates[1],
				};
				this.mapConfig.latitude = parseFloat(coordinates.lat);
				this.mapConfig.longitude = parseFloat(coordinates.lng);
				this.showGeoAgain = false;
			} else {
				this.formatData = {
					country: "",
					department: "",
					city: "",
					address: "",
					addressOld: "",
					cx: 0,
					cy: 0,
					typeDeposit: "EndDeposit",
				};
			}
			this.formatData.typeDeposit = "EndDeposit";
			this.isDisabled = true;
			this.popupMapMounted = true;
			this.geoAlert = true;
		},
		async callbackClick(markerEvent) {
			this.geoReverse({
				cy: markerEvent.latLng.lat(),
				cx: markerEvent.latLng.lng(),
			});
			this.map.removeMarker(this.marker);
			this.marker = this.map.addMarkerToMap(
				{cy: markerEvent.latLng.lat(), cx: markerEvent.latLng.lng()},
				{
					icon: phonesSuccess,
					draggable: true,
					infoWindow: {
						content: `
							<div class='flex items-center mt-2'>
								<span class='text-ms'>${markerEvent.latLng.lat()}, ${markerEvent.latLng.lng()}</span>
							</div>
						`,
					},
					onDragend: (coords) => {
						this.geoReverse({
							cy: coords.lat,
							cx: coords.lng,
						});
					},
				}
			);
		},
		getCoordinatesDrag(markerEvent) {
			this.geoReverse({
				cy: markerEvent.lat,
				cx: markerEvent.lng,
			});
		},
		confirmCoordinates(data) {
			if (this.formatData.typeDeposit === "InitDeposit") {
				this.resource.init_depot = `${(+data.cy).toFixed(8)},${(+data.cx).toFixed(8)}`;
			} else if (this.formatData.typeDeposit === "EndDeposit") {
				this.resource.end_depot = `${(+data.cy).toFixed(8)},${(+data.cx).toFixed(8)}`;
			}
			this.popupMapMounted = false;
		},
		closeSidebarAddResource() {
			this.$emit("closeSidebarEmit");
		},
		showPromptBreaks() {
			this.showPromptBreak = true;
			this.isUpdateBreak = false;
			this.resource.breaks = {
				init_date_window: "",
				end_date_window: "",
				init_hour_window: "",
				end_hour_window: "",
			};
			this.resource.min_break_hours = 0;
			this.resource.min_break_minutes = 0;
			this.resource.min_break_seconds = 0;
		},
		editSelectBreak(val, index) {
			this.isUpdateBreak = true;
			this.showPromptBreak = true;
			this.resource.breaks.init_date_window = moment(val.init_date_window).format();
			this.resource.breaks.end_date_window = moment(val.end_date_window).format();
			this.resource.breaks.init_hour_window = val.init_hour_window;
			this.resource.breaks.end_hour_window = val.end_hour_window;
			this.resource.min_break_hours = val.min_break_hours || 0;
			this.resource.min_break_minutes = val.min_break_minutes || 0;
			this.resource.min_break_seconds = val.min_break_seconds || 0;
			this.indexUpdateBreak = index;
		},
		updatePropertyBreak(propertyBreak) {
			this.propertiesListBreak[this.indexUpdateBreak].init_date_window = propertyBreak.init_date_window;
			this.propertiesListBreak[this.indexUpdateBreak].end_date_window = propertyBreak.end_date_window;
			this.propertiesListBreak[this.indexUpdateBreak].init_hour_window = propertyBreak.init_hour_window;
			this.propertiesListBreak[this.indexUpdateBreak].end_hour_window = propertyBreak.end_hour_window;
			this.propertiesListBreak[this.indexUpdateBreak].min_break_hours = this.resource.min_break_hours;
			this.propertiesListBreak[this.indexUpdateBreak].min_break_minutes = this.resource.min_break_minutes;
			this.propertiesListBreak[this.indexUpdateBreak].min_break_seconds = this.resource.min_break_seconds;
			this.propertiesListBreak[this.indexUpdateBreak].min_break_duration = this.formatMinBreakDuration({
				min_break_hours: this.resource.min_break_hours,
				min_break_minutes: this.resource.min_break_minutes,
				min_break_seconds: this.resource.min_break_seconds,
			});
		},
		deleteItemBreak(indexItem) {
			this.propertiesListBreak.splice(indexItem, 1);
		},
		addPropertyBreak(propertyBreak) {
			propertyBreak.init_date_window = DateUtils.toDefaultDateTime(propertyBreak.init_date_window, "YYYY-MM-DD");
			propertyBreak.end_date_window = DateUtils.toDefaultDateTime(propertyBreak.end_date_window, "YYYY-MM-DD");

			// Agregar min_break_duration en formato string
			propertyBreak.min_break_duration = this.formatMinBreakDuration({
				min_break_hours: this.resource.min_break_hours,
				min_break_minutes: this.resource.min_break_minutes,
				min_break_seconds: this.resource.min_break_seconds,
			});

			// Agregar las variables separadas
			propertyBreak.min_break_hours = this.resource.min_break_hours;
			propertyBreak.min_break_minutes = this.resource.min_break_minutes;
			propertyBreak.min_break_seconds = this.resource.min_break_seconds;

			let findOther = this.propertiesListBreak.findIndex(
				(elem) =>
					elem.init_date_window === propertyBreak.init_date_window &&
					elem.end_date_window === propertyBreak.end_date_window &&
					elem.init_hour_window === propertyBreak.init_hour_window &&
					elem.end_hour_window === propertyBreak.end_hour_window &&
					elem.min_break_hours === propertyBreak.min_break_hours &&
					elem.min_break_minutes === propertyBreak.min_break_minutes &&
					elem.min_break_seconds === propertyBreak.min_break_seconds
			);
			if (this.isUpdateBreak) {
				this.updatePropertyBreak(propertyBreak);
				this.resource.breaks = {
					init_date_window: "",
					end_date_window: "",
					init_hour_window: "",
					end_hour_window: "",
				};
				this.resource.min_break_hours = 0;
				this.resource.min_break_minutes = 0;
				this.resource.min_break_seconds = 0;
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (findOther == -1) {
				this.propertiesListBreak.push(propertyBreak);
				this.resource.breaks = {
					init_date_window: "",
					end_date_window: "",
					init_hour_window: "",
					end_hour_window: "",
				};
				this.resource.min_break_hours = 0;
				this.resource.min_break_minutes = 0;
				this.resource.min_break_seconds = 0;
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
			this.$validator.pause();
			this.$nextTick(() => {
				this.$validator.errors.clear();
				this.$validator.fields.items.forEach((field) => field.reset());
				this.$validator.fields.items.forEach((field) => this.errors.remove(field));
				this.$validator.resume();
			});
		},
		addTimeWindow() {
			this.isTimeWindow = true;
		},
		deleteTimeWindow() {
			this.resource.time_window = {
				init_date_window: "",
				end_date_window: "",
				init_hour_window: "",
				end_hour_window: "",
			};
			this.isTimeWindow = false;
		},
		removeError(errorName) {
			const index = this.errors.items.findIndex((e) => e.field === errorName);
			this.errors.items.splice(index, 1);
		},
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		validatorInitDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const ih = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const eh =
				typeof this.resource.breaks.end_date_window === "string"
					? new Date(this.resource.breaks.end_date_window).getTime()
					: this.resource.breaks.end_date_window.getTime();
			return ih <= eh;
		},
		validatorEndDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const eh = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const ih =
				typeof this.resource.breaks.init_date_window === "string"
					? new Date(this.resource.breaks.init_date_window).getTime()
					: this.resource.breaks.init_date_window.getTime();
			return eh >= ih;
		},
		validatorEndHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			if (this.resource.breaks.init_hour_window === "" || value === "") {
				return true;
			}
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.resource.breaks.init_hour_window);
		},
		validatorInitHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			if (this.resource.breaks.end_hour_window === "" || value === "") {
				return true;
			}
			return this.stringTimeToDate(value) < this.stringTimeToDate(this.resource.breaks.end_hour_window);
		},
		validatorMinBreakDuration(value, args) {
			this.removeError("minBreakDuration");

			// Validar que se haya ingresado fecha y hora de inicio y fin
			if (
				!this.resource.breaks.init_date_window ||
				!this.resource.breaks.end_date_window ||
				!this.resource.breaks.init_hour_window ||
				!this.resource.breaks.end_hour_window
			) {
				return true;
			}

			// Calcular la duración total del break
			const initDate = new Date(this.resource.breaks.init_date_window);
			const endDate = new Date(this.resource.breaks.end_date_window);
			const initTime = this.stringTimeToDate(this.resource.breaks.init_hour_window);
			const endTime = this.stringTimeToDate(this.resource.breaks.end_hour_window);

			// Combinar fecha y hora
			const startDateTime = new Date(initDate);
			startDateTime.setHours(initTime.getHours(), initTime.getMinutes(), initTime.getSeconds());

			const endDateTime = new Date(endDate);
			endDateTime.setHours(endTime.getHours(), endTime.getMinutes(), endTime.getSeconds());

			// Calcular duración total en milisegundos
			const totalDurationMs = endDateTime.getTime() - startDateTime.getTime();

			// Convertir la duración mínima ingresada a milisegundos
			const minBreakDurationMs =
				(this.resource.min_break_hours * 3600 +
					this.resource.min_break_minutes * 60 +
					this.resource.min_break_seconds) *
				1000;

			// Validar que la duración mínima no exceda la duración total del break
			return minBreakDurationMs <= totalDurationMs;
		},
		formatMinBreakDuration(breakData) {
			// Si breakData es un objeto con las propiedades separadas
			if (breakData.min_break_hours !== undefined) {
				const hours = breakData.min_break_hours || 0;
				const minutes = breakData.min_break_minutes || 0;
				const seconds = breakData.min_break_seconds || 0;

				if (hours === 0 && minutes === 0 && seconds === 0) {
					return "-";
				}

				return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}:${
					seconds < 10 ? "0" + seconds : seconds
				}`;
			}

			// Si breakData es un string (formato HH:MM:SS)
			if (typeof breakData === "string" && breakData !== "-") {
				return breakData;
			}

			return "-";
		},
		showPromptErrorService() {
			this.listErrorFilter = this.$store.state.moduleOptimization.errorList.filter(
				(element) =>
					element.absolute_path[0] === "vehicles" &&
					element.absolute_path[1] === this.resourceEdit.indexResource &&
					element.absolute_path.length <= 2
			);
			if (this.listErrorFilter.length > 0) this.activeAlertError = true;
		},
		showPromptError(namePropertyFirst, title) {
			this.arrayErrors = this.validateErrorProperty(namePropertyFirst);
			this.titlePromptErrorVisitPoint = title;
			this.activePromptErrorVisitPoint = true;
		},
		showPromptErrorArray(nameProperty, index, title) {
			this.arrayErrors = this.validateErrorPropertyArray(nameProperty, index);
			this.titlePromptErrorVisitPoint = title;
			this.activePromptErrorVisitPoint = true;
		},
		AddSofTimeWindow() {
			if (!this.validFormTimeWindowComputed) {
				this.isAlertTimeWindow = true;
				this.isSoftTimeWindow = false;
			} else {
				this.addSoftWindowToTimeWindow();
				this.isSoftTimeWindow = true;
				this.isAlertTimeWindow = false;
			}
		},
		deleteSoftWindow() {
			delete this.resource.time_window["soft_time_window"];
			this.isSoftTimeWindow = false;
			this.validFormTimeWindowComputed = true;
		},
		addSoftWindowToTimeWindow() {
			this.resource.time_window = {
				...this.resource.time_window,
				soft_time_window: {
					init_date: "",
					end_date: "",
					init_hour: "",
					end_hour: "",
					cost_per_hour_before: 0,
					cost_per_hour_after: 0,
				},
			};
		},
		checkZeroMaxDistanceToNeighbor() {
			if (
				!this.resource.clustering.max_distance_to_neighbor ||
				this.resource.clustering.max_distance_to_neighbor === ""
			) {
				this.resource.clustering.max_distance_to_neighbor = 25;
			}
		},
		checkZeroMaxDiameter() {
			if (!this.resource.clustering.max_diameter || this.resource.clustering.max_diameter === "") {
				this.resource.clustering.max_diameter = 100;
			}
		},
		// Método para validar los campos específicos
		validatePerCost() {
			if (this.resource && this.resource.time_window && this.resource.time_window.soft_time_window) {
				Utils.checkZero("cost_per_hour_after", this.resource.time_window.soft_time_window);
				Utils.checkZero("cost_per_hour_before", this.resource.time_window.soft_time_window);
			}
		},
		checkIdentification() {
			this.isDisabledIdentification =
				!this.resourceEdit.identification || this.resourceEdit.identification === "";
		},
		setAdditionalInfo() {
			if (
				this.resourceEdit.hasOwnProperty("additional_info") &&
				this.isNonEmptyObject(this.resourceEdit.additional_info)
			) {
				const additionalInfoKeys = Object.keys(this.resourceEdit.additional_info);
				const additionalInfoValues = Object.values(this.resourceEdit.additional_info);
				this.propertiesList = additionalInfoKeys.map((key, index) => ({
					label: key,
					value: additionalInfoValues[index],
					type: {},
				}));
			} else {
				this.propertiesList = [];
			}
		},
		setIdentificationAndDistance() {
			this.resource.identification = this.resourceEdit.identification || "";
			this.resource.original_identification = this.resourceEdit.original_identification || "";
			this.resource.max_travel_distance = this.resourceEdit.max_travel_distance;
			this.resource.strict_territories =
				this.resourceEdit.territories && this.resourceEdit.territories.strict
					? this.resourceEdit.territories.strict
					: false;
		},
		setInitDepot() {
			if (this.isNonEmptyObject(this.resourceEdit.init_depot)) {
				this.resource.init_depot = `${this.resourceEdit.init_depot.latitude},${this.resourceEdit.init_depot.longitude}`;
			} else {
				this.resource.init_depot = "";
			}
		},
		setProperties() {
			this.propertiesListSkill = this.resourceEdit.skills || [];
			this.propertiesListDemand = this.resourceEdit.capacity || [];
			this.propertiesListBreak = this.processExistingBreaks(this.resourceEdit.breaks || []);
			this.propertiesListTerritory =
				this.resourceEdit.territories && this.resourceEdit.territories.items
					? this.resourceEdit.territories.items
					: [];
			this.resource.additional_info = this.resourceEdit.additional_info || {};
		},
		processExistingBreaks(breaks) {
			return breaks.map((breakItem) => {
				const processedBreak = {
					init_date_window: breakItem.init_date_window,
					end_date_window: breakItem.end_date_window,
					init_hour_window: breakItem.init_hour_window,
					end_hour_window: breakItem.end_hour_window,
					min_break_hours: 0,
					min_break_minutes: 0,
					min_break_seconds: 0,
				};

				// Si existe min_break_duration en formato string, convertirlo
				if (breakItem.min_break_duration) {
					const timeParts = breakItem.min_break_duration.split(":");
					if (timeParts.length === 3) {
						processedBreak.min_break_hours = parseInt(timeParts[0]) || 0;
						processedBreak.min_break_minutes = parseInt(timeParts[1]) || 0;
						processedBreak.min_break_seconds = parseInt(timeParts[2]) || 0;
					}
				}

				return processedBreak;
			});
		},
		setProfile() {
			const profileMap = {
				walk: 1,
				bicycle: 2,
				motorcycle: 3,
				truck: 4,
				scooter: 5,
				bus: 6,
			};
			this.resource.profile = this.profileOptions[profileMap[this.resourceEdit.profile] || 0];
		},
		setTravelDuration() {
			if (this.resourceEdit.max_travel_duration) {
				const [hours, minutes, seconds] = this.resourceEdit.max_travel_duration.split(":");
				this.resource.hours = parseInt(hours, 10);
				this.resource.minutes = parseInt(minutes, 10);
				this.resource.seconds = parseInt(seconds, 10);
			}
		},
		setCosts() {
			if (this.isNonEmptyObject(this.resourceEdit.costs)) {
				const costs = this.resourceEdit.costs;
				// Detectar el origen basado en las claves disponibles
				const isFromFile =
					costs.hasOwnProperty("fixed_cost") ||
					costs.hasOwnProperty("distance_cost") ||
					costs.hasOwnProperty("time_cost") ||
					costs.hasOwnProperty("traveled_hour_cost");

				if (isFromFile) {
					const costMapping = {
						fixed: "fixed_cost",
						distance: "distance_cost",
						time: "time_cost",
						traveled_hour: "traveled_hour_cost",
					};
					Object.entries(costMapping).forEach(([sourceKey, targetKey]) => {
						if (costs.hasOwnProperty(targetKey)) {
							this.resource.costs[sourceKey] = costs[targetKey];
						}
					});
					if (this.resourceEdit.identification !== undefined) {
						const currentStandardInputVehicles =
							this.$store.state.moduleOptimization.standardInputList.vehicles;
						const vehicleIndex = currentStandardInputVehicles.findIndex(
							(vehicle) => vehicle.identification === this.resourceEdit.identification
						);

						if (vehicleIndex !== -1) {
							// Crear el payload actualizado
							const updatedVehicle = {
								...currentStandardInputVehicles[vehicleIndex],
								costs: this.resource.costs,
							};
							// Actualizar en el store
							this.$store.commit("moduleOptimization/UPDATE_VEHICLE_STANDARD_INPUT", updatedVehicle);
						}
					}
				} else {
					this.resource.costs = {...costs};
				}
			}
		},
		setClustering() {
			if (this.resourceEdit.clustering != null) {
				this.resource.clustering = this.resourceEdit.clustering;
				this.isClusteredRoute = true;
			} else {
				this.isClusteredRoute = false;
			}
		},
		setTimeWindow() {
			const timeWindow = this.resourceEdit.time_window || {};
			if (
				timeWindow.init_date_window &&
				timeWindow.end_date_window &&
				timeWindow.init_hour_window &&
				timeWindow.end_hour_window
			) {
				this.resource.time_window = {
					init_date_window: moment(timeWindow.init_date_window).format(),
					end_date_window: moment(timeWindow.end_date_window).format(),
					init_hour_window: timeWindow.init_hour_window,
					end_hour_window: timeWindow.end_hour_window,
				};
				this.isTimeWindow = true;

				if (timeWindow.hasOwnProperty("soft_time_window")) {
					this.addSoftWindowToTimeWindow();
					const softTimeWindow = timeWindow.soft_time_window;
					this.resource.time_window.soft_time_window = {
						init_date: moment(softTimeWindow.init_date).format(),
						end_date: moment(softTimeWindow.end_date).format(),
						init_hour: softTimeWindow.init_hour,
						end_hour: softTimeWindow.end_hour,
						cost_per_hour_before: softTimeWindow.cost_per_hour_before,
						cost_per_hour_after: softTimeWindow.cost_per_hour_after,
					};
					this.isSoftTimeWindow = true;
					this.isAlertTimeWindow = false;
				}
			}
		},
		setEndDepot() {
			if (this.isNonEmptyObject(this.resourceEdit.end_depot)) {
				this.resource.end_depot = `${this.resourceEdit.end_depot.latitude},${this.resourceEdit.end_depot.longitude}`;
			} else {
				this.resource.end_depot = "";
			}
		},
		isNonEmptyObject(obj) {
			return obj && obj.constructor === Object && Object.keys(obj).length > 0;
		},
		showPromptTerritories() {
			this.showPromptTerritory = true;
			this.isUpdateTerritory = false;
			this.resource.territories = {
				id: "",
				priority: 0,
			};
		},
		addPropertyTerritory(propertyTerritory) {
			propertyTerritory = {
				id: propertyTerritory.id,
				priority: parseInt(propertyTerritory.priority),
			};
			let findOther = this.propertiesListTerritory.findIndex((elem) => elem.id === propertyTerritory.id);
			if (findOther == -1) {
				this.propertiesListTerritory.push(propertyTerritory);
				this.resource.territories = {
					id: "",
					priority: 0,
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdateTerritory) {
				this.updatePropertyTerritory(propertyTerritory);
				this.resource.territories = {
					id: "",
					priority: 0,
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
					time: 8000,
				});
			}
		},
		deleteItemTerritory(indexItem) {
			this.propertiesListTerritory.splice(indexItem, 1);
		},
		editSelectTerritory(val, index) {
			this.isUpdateTerritory = true;
			this.showPromptTerritory = true;
			this.resource.territories.id = val.id;
			this.resource.territories.priority = val.priority;
			this.indexUpdateTerritory = index;
		},
		updatePropertyTerritory(propertyTerritory) {
			this.propertiesListTerritory[this.indexUpdateTerritory].id = propertyTerritory.id;
			this.propertiesListTerritory[this.indexUpdateTerritory].priority = propertyTerritory.priority;
		},
		validateInputName(event) {
			let regex = /^[a-zA-Z0-9_-]+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
	},
	watch: {
		dataCity(val) {
			if (val) {
				this.formatData.city = typeof val === "object" ? val.value : val;
			}
		},
		selectedCountry(val) {
			if (val === null || val === undefined) {
				return;
			}
			this.formatData.country = typeof val === "object" ? val.value : val;
			this.getDepartments(val.label);
		},
		selectedDepartment(val) {
			if (val === null || val === undefined) {
				return;
			}
			this.formatData.department = typeof val === "object" ? val.value : val;
			this.getCities(val.value);
		},
		hours(val) {
			if (val > 24) {
				this.hours = 24;
			}
		},
		minutes(val) {
			if (val > 59) {
				this.minutes = 59;
			}
		},
		seconds(val) {
			if (val > 59) {
				this.seconds = 59;
			}
		},
		"resource.min_break_hours"(val) {
			if (val < 0) {
				this.resource.min_break_hours = 0;
			}
		},
		"resource.min_break_minutes"(val) {
			if (val < 0) {
				this.resource.min_break_minutes = 0;
			}
			if (val > 59) {
				this.resource.min_break_minutes = 59;
			}
		},
		"resource.min_break_seconds"(val) {
			if (val < 0) {
				this.resource.min_break_seconds = 0;
			}
			if (val > 59) {
				this.resource.min_break_seconds = 59;
			}
		},
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries.length <= 0) {
			this.$store
				.dispatch("moduleCommon/getCountries")
				.then((res) => {
					if (res.data.length === 1) {
						this.selectedCountry = res.data[0]["country_name"].toUpperCase();
					}
				})
				.catch((error) => {
					console.error(error);
				});
		}
		// Create Custom Validators
		Validator.extend("validatorEndHour", this.validatorEndHour);
		Validator.extend("validatorInitHour", this.validatorInitHour);
		Validator.extend("validatorInitDate", this.validatorInitDate);
		Validator.extend("validatorEndDate", this.validatorEndDate);
		Validator.extend("validatorMinBreakDuration", this.validatorMinBreakDuration);
	},
};
